import React, { createContext, useState } from 'react';
import LifeAtToastV2 from '@common/LifeAtToastV2/LifeAtToastV2';

const DEFAULT_DURATION = 7000;

interface ToastInfo {
  title: string;
  description: string;
  duration: number;
}

type ToastListContext = {
  addToastNotification: (title: string, description: string, durationMs?: number) => void;
};

export const ToastListContext = createContext<ToastListContext | undefined>(undefined);

type ToastListContextProviderProps = {
  children?: React.ReactNode;
};

export function ToastListContextProvider({ children }: ToastListContextProviderProps) {
  const [toastListState, setToastListState] = useState<ToastInfo[]>([]);
  const addToastNotification = (title: string, description: string, durationMs?: number) => {
    setToastListState([
      ...toastListState,
      {
        title: title,
        description: description,
        duration: durationMs || DEFAULT_DURATION,
      },
    ]);
  };

  return (
    <ToastListContext.Provider value={{ addToastNotification: addToastNotification }}>
      {children}
      {toastListState.map((toast, index) => {
        return (
          <LifeAtToastV2
            root={{
              type: 'background',
              duration: toast.duration,
            }}
            title={toast.title}
            description={toast.description}
            key={`toast-list-${index}`}
          />
        );
      })}
    </ToastListContext.Provider>
  );
}

export function useToastListContext() {
  const context = React.useContext(ToastListContext);
  if (!context) {
    throw new Error('useToastList must be used within a ToastListContextProvider');
  }
  return context;
}
